import { Component, computed, inject, signal } from '@angular/core';
import { DroplistItem, DroplistWidget } from '@eforall/dashboard';
import { StaticDataService } from 'services';
import { AddDashboardDialogService } from '../add-dashboard.dialog.service';
import { getDisplayTypeItems } from './get-display-type-items';


@Component({
	selector: 'add-dashboard-step-2',
	standalone: true,
	imports: [DroplistWidget],
	templateUrl: './add-dashboard-step-2.part.html',
	styleUrl: './add-dashboard-step-2.part.scss',
})

export class AddDashboardStep2Part {

	public service = inject(AddDashboardDialogService);
	private staticData = inject(StaticDataService);

	public readonly displayTypeItems = computed(() => { return getDisplayTypeItems(this.staticData); });

	private _selectedDisplayTypeItem = signal<DroplistItem<unknown, number> | undefined>(undefined);
	public selectedDisplayTypeItem = this._selectedDisplayTypeItem.asReadonly();

	public onDatasetChange(item: DroplistItem<unknown, number> | undefined) {
		if (item) this._selectedDisplayTypeItem.set(item);
	}


	public selectDisplayType() {
		const item = this.selectedDisplayTypeItem();
		if (item == undefined) return;
		this.service.setDisplayTypeId(item.uniqueId);
	}

}